import React, { Component } from 'react';
import Page from './Page';
import { injectIntl } from 'react-intl';
import * as Secrets from '../../config/secrets'
import createApp from '@shopify/app-bridge';
import {Redirect, Print} from '@shopify/app-bridge/actions';

class PrintPOS extends Component {
    getMetaData() {
        return {
            title: this.pageTitle(),
            meta: this.pageMeta(),
            link: this.pageLink()
        };
    }

    pageTitle = () => {
        return 'Print Order';
    };

    pageMeta = () => {
        return [
            { name: 'description', content: 'Print Order' }
        ];
    };

    pageLink = () => {
        return [];
    };

    componentDidMount(){

            const config = {
                apiKey: Secrets.shopify.clientID,
                host: new URLSearchParams(location.search).get("host"),
                forceRedirect: true
            };

            try{
            
            const app = createApp(config);
           // const redirect = Redirect.create(app);
           

            app.dispatch(Redirect.toRemote({
                url: 'https://invoicebrowse.growth-connections.com/template/Receipt/receipt.pdf' + location.search,
                newContext: true,
            }));

            app.dispatch(Print.Action.APP);

            print();

            }catch(e){
                this.setState({
                    err: e.message
                })
            }
    }

    render() {
        if (typeof window === "undefined") {
            return <div>Loading...</div>
        }
        return (
            <Page {...this.getMetaData()}>
                <style>
                    {`
                        .app-container{
                            margin-top:0!important;
                            margin: 5px!important;
                        }
                        .layout-nav{
                            display:none;
                        }
                    `}
                </style>
                <div>Printing...{location? location.href: ''}</div>
                <div>{this.state && this.state.err}</div>
            </Page>
        );
    }
}

export default injectIntl(PrintPOS);




// WEBPACK FOOTER //
// app/pages/PrintPOS.jsx